<template>
    <div>
        <headerNotice routerName="添加首页弹窗促销"></headerNotice>
        <el-form class="from-el addHWPromotion" :model="formData">
            <el-form-item :rules="{required: true}" label="首页促销名称:" label-width="138px">
                <el-input
                    placeholder="不能为空，1~20个字符"
                    class="input-el"
                    v-model="formData.title"
                    autocomplete="off"
                    style="width:65%;"
                    maxlength="20"
                ></el-input>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="开始时间:" label-width="138px">
                <el-date-picker
                    :readonly="readonly"
                    v-model="formData.startTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择开始时间"
                    default-time="12:00:00"
                ></el-date-picker>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="结束时间:" label-width="138px">
                <el-date-picker
                    :readonly="readonly"
                    v-model="formData.endTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择结束时间"
                    default-time="12:00:00"
                ></el-date-picker>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="适合的客户:" label-width="140px">
                <el-radio-group v-model="formData.customerScope">
                    <el-radio :label="1">全部客户</el-radio>
                    <el-radio :label="2">新客户</el-radio>
                    <el-radio :label="3">老客户</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="活动范围:" label-width="140px">
                <el-radio-group v-model="formData.cityScope">
                    <el-radio :label="1">全部地区</el-radio>
                    <el-radio :label="2">指定地区</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                :rules="{required: true}"
                label="地区选择:"
                label-width="140px"
                v-if="formData.cityScope == 2"
            >
                <el-button style="margin-right:35px;" @click="showArea = true">选择地区</el-button>
                已选择
                {{areaNumber}}个地区
            </el-form-item>
            <el-form-item :rules="{required: true}" label="活动内容:" label-width="140px">
                <el-checkbox-group
                    @change="valChange"
                    v-model="formData.contentType"
                    style="width:45%;"
                >
                    <el-row style="line-height:40px;">
                        <el-col :span="6">
                            <el-checkbox label="1">优惠券</el-checkbox>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item v-if="activityOptions3 == '-1'">
                                <el-button
                                    :disabled="activityOptions1"
                                    @click="showCoupon = true"
                                >选择优惠券</el-button>
                                已选择
                                {{couponNum}}个优惠券
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-row style="line-height:40px;">
                        <el-col :span="6">
                            <el-checkbox label="2">红包</el-checkbox>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item>
                                <el-input
                                    :readonly="readonly"
                                    placeholder="0.0"
                                    class="input-el"
                                    v-model="formData.redEnvelopeAmount"
                                    autocomplete="off"
                                    type="number"
                                    v-if="activityOptions3 == '-1'"
                                    :disabled="activityOptions2"
                                >
                                    <template slot="prepend">红包金额</template>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                    <el-row style="line-height:40px;">
                        <el-col :span="7">
                            <el-checkbox label="3">公告</el-checkbox>
                        </el-col>
                    </el-row>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="活动图片:" label-width="140px">
                <el-upload
                    :accept='accept'
                    :headers="headers"
                    class="avatar-uploader avatarBox"
                    :action="uploadAction"
                    :show-file-list="false"
                    :on-success="handleAddSuccess"
                    :before-upload="beforeUpload"
                >
                    <img v-if="formData.imgUrl" :src="baseUrl+formData.imgUrl" class="avatar">
                    <el-button size="small" type="primary">选择上传文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png格式文件，文件不能超过500kb</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="促销活动描述:" label-width="138px">
                <el-input
                    :readonly="readonly"
                    placeholder="不超过200字"
                    :rows="4"
                    class="input-el"
                    v-model="formData.content"
                    autocomplete="off"
                    type="textarea"
                ></el-input>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="弹窗触发模式:" label-width="140px">
                <el-radio-group v-model="formData.popupType">
                    <el-radio :label="1">首次触发</el-radio>
                    <el-radio :label="2">每天触发</el-radio>
                    <el-radio :label="3">自定义</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                :rules="{required: true}"
                label="自定义:"
                label-width="138px"
                v-if="formData.popupType == 3"
            >
                <el-input
                    placeholder="只能输入正整数"
                    class="input-el"
                    v-model="formData.intervalDays"
                    autocomplete="off"
                    type="number"
                    style="width:40%;"
                >
                    <template slot="prepend">每</template>
                    <template slot="append">天触发</template>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer footBtn">
            <el-button @click="goBack">取 消</el-button>
            <el-button
                type="primary"
                :loading="btnLoading = false"
                @click="addHomeWindowPromotion"
            >确 定</el-button>
        </div>
        <!-- 地区选择Dialog框 -->
        <div class="add-box">
            <el-dialog width="500px" title="选择地区:" :visible.sync="showArea">
                <div v-loading="dialogLoading">
                    <el-tree
                        :data="reginData"
                        show-checkbox
                        node-key="code"
                        :default-checked-keys="defaultKeys"
                        accordion
                        :props="defaultProps"
                        ref="reginTree"
                    ></el-tree>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showArea = false">取 消</el-button>
                    <el-button type="primary" @click="getArea">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 优惠券选择Dialog框 -->
        <div class="add-box">
            <el-dialog width="750px" title="选择商品:" :visible.sync="showCoupon">
                <el-form class="from-el">
                    <!-- 搜索框 -->
                    <el-col :span="12" :offset="0">
                        <el-input placeholder="商品名称/商品编码" v-model="word">
                            <el-button slot="append" icon="el-icon-search" @click="searchCoupon"></el-button>
                        </el-input>
                    </el-col>
                    <el-table
                        ref="multipleTable"
                        :data="CouponList"
                        style="width: 100%"
                        :default-sort="{prop: 'date', order: 'descending'}"
                        @selection-change="handleCustomerSelectionChange"
                        v-loading="dialogLoading"
                    >
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="couponName" label="优惠券名称" width="300"></el-table-column>
                        <el-table-column prop="abate" label="面额"></el-table-column>
                        <el-table-column prop="remainderCount" label="剩余张数"></el-table-column>
                        <el-table-column prop="reach" label="使用条件"></el-table-column>
                        <el-table-column prop="timer" label="有效期"></el-table-column>
                    </el-table>
                    <!--分页-->
                    <el-pagination
                        class="pagination"
                        @size-change="handleGoodsSizeChange"
                        @current-change="handleGoodsCurrentChange"
                        :page-sizes="[25, 50, 75, 100]"
                        layout="total, sizes, next"
                        :background="true"
                        next-text="点击加载更多⇣⇣"
                        :total="couponTotalCount"
                    ></el-pagination>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showCoupon = false">取 消</el-button>
                    <el-button type="primary" @click="getCouponNum">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import headerNotice from "./../../components/common/headerNotice.vue";
const cityOptions = ["1"];
const valArr = [];
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            uploadAction:
                this.$store.state.apiUrl +
                "/api/services/app/Image/UploadImage", //上传的服务器api地址
            headers: {
                Authorization: localStorage.getItem("accessToken")
            },
            accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            activityOptions1: false, // 活动内容状态值
            activityOptions2: false, // 活动内容状态值
            activityOptions3: "-1", // 活动内容状态值
            params: {}, // 传输到接口的值
            readonly: false, // 编辑时部分数据设置只读
            dialogLoading: true, // loading状态
            loading: true, // loading状态
            btnLoading: true, // loading状态
            maxResultCount: 25, //默认一页显示的个数,
            formData: { // 要添加的数据
                title: "",
                startTime: "",
                endTime: "",
                customerScope: 0,
                cityScope: 0,
                popupType: 0,
                intervalDays: 0,
                contentType: cityOptions,
                redEnvelopeAmount: 0,
                content: "",
                imgUrl: "",
                fileName: "",
                couponIDs: [],
                cityCodes: []
            },
            reginData: [], //区域数据
            defaultProps: {
                children: "children",
                label: "name"
            },
            defaultKeys: [],
            areaNumber: 0, // 选中地区数量
            couponNum: 0, // 选中优惠券数量
            CouponList: [], // 优惠券列表
            CouponForm: {}, // 优惠券搜索框
            showArea: false, // 是否展示地区列表弹出框
            showCoupon: false, // 是否展示赠品列表弹出框
            currentPageCustomer: [], //所有页选中的优惠券数据
            nowCurrentPageCustomer: [], //当前页选中的优惠券数据
            currentPageCustomerData: [], //所有选中的优惠券数据
            couponTotalCount: 0,//优惠券总数据条数
            word: "" // 优惠券搜索框数据
        };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getAllRegin();
        this.getCoupon({
            MaxResultCount: this.maxResultCount
        }, true);
    },
    methods: {
        // 返回
        goBack() {
            self.$router.push({ path:'/homeWindowPromotion'});
        },
        // 获取活动内容 选择的值
        valChange(e) {
            let self = this;
            self.activityOptions3 = e.indexOf("3");
            if (self.activityOptions3 != "-1") {
                self.formData.contentType = ["3"];
                return false;
            }
            if (e.indexOf("1") != "-1") {
                self.activityOptions1 = false;
            } else {
                self.activityOptions1 = true;
                if (self.$refs.multipleTable) {
                    self.$refs.multipleTable.clearSelection();
                }
                self.couponNum = 0;
            }
            if (e.indexOf("2") != "-1") {
                self.activityOptions2 = false;
            } else {
                self.activityOptions2 = true;
                self.formData.redEnvelopeAmount = 0;
            }

        },
        // 上传图片之前
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 0.5;
            if (file.type != "image/jpeg" && file.type != "image/png") {
                this.$message.error("上传的图片只支持JPG/PNG 的格式!");
                return false;
            }
            return true;
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 1MB!");
            }
            return isLt2M;
        },
        // 图片上传成功
        handleAddSuccess(response, file, fileList) {
            this.formData.imgUrl = response.result.url;
            this.formData.fileName = response.result.fileName;
        },
        // 添加优惠券
        addHomeWindowPromotion() {
            let self = this;
            self.btnLoading = true;
            if (
                !self.formData.title ||
                !self.formData.startTime ||
                !self.formData.endTime ||
                !self.formData.customerScope ||
                !self.formData.cityScope ||
                !self.formData.popupType ||
                !self.formData.contentType ||
                !self.formData.fileName
            ) {
                self.$message.error("请检查必填项是否填写！");
                self.btnLoading = false;
                return;
            }
            let contentType = 0;
            let popupType = 0;
            if (self.formData.contentType.length == 1) {
                if (self.formData.contentType[0] == 1) {
                    contentType = 1;
                } else if (self.formData.contentType[0] == 2) {
                    contentType = 2;
                } else if (self.formData.contentType[0] == 3) {
                    contentType = 3;
                } else {
                    contentType = 4;
                }
            } else {
                contentType = 4;
            }
            if (self.formData.popupType == 1) {
                popupType = 1;
                self.formData.intervalDays = 0;
            } else if (self.formData.popupType == 2) {
                popupType = 2;
                self.formData.intervalDays = 1;
            } else {
                popupType = 2;
            }
            let setData = {
                title: self.formData.title,
                startTime: self.formData.startTime,
                endTime: self.formData.endTime,
                customerScope: self.formData.customerScope,
                cityScope: self.formData.cityScope,
                popupType: popupType,
                intervalDays: self.formData.intervalDays,
                contentType: contentType,
                redEnvelopeAmount: self.formData.redEnvelopeAmount,
                content: self.formData.content,
                imgUrl: self.formData.fileName,
                couponIDs: self.formData.couponIDs,
                cityCodes: self.formData.cityCodes
            };
            $http.POST({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminPopupPromotion/Create",
                data: setData,
                success(res) {
                    self.$message({
                        message: "添加成功",
                        type: "success"
                    });
                    self.btnLoading = false;
                    self.$router.push({ path:'/homeWindowPromotion'})
                },
                fail(res) {
                    self.btnLoading = false;
                }
            });
        },
        // 开启选择地区dialog框 获取所有省市区数据
        getAllRegin() {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetProvinceList",
                success(res) {
                    self.reginData = res;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 获取已选中的省市区数据
        getArea() {
            let self = this;
            self.showArea = false;
            let val = self.$refs.reginTree.getCheckedKeys(true, false).length;
            self.areaNumber = val;
            let arr = self.$refs.reginTree
                .getCheckedKeys(true, false)
                .map(item => Number.parseInt(item));
            self.formData.cityCodes = arr;
        },
        // 获取优惠券列表数据
        getCoupon(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminPopupPromotion/GetCouponList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.CouponList = res.items;
                    } else {
                        self.CouponList = self.CouponList.concat(res.items);
                    }
                    self.CouponList.forEach((ele1, index1) => {
                        self.currentPageCustomer.forEach((ele2, index2) => {
                            if(ele1.propID == ele2.propID){
                                setTimeout(() => {
                                    self.$refs.multipleTable.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                }, 10);
                            }
                        })
                    })
                    self.couponTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 根据优惠券名称/优惠券编号查询
        searchCoupon() {
            let self = this;
            let Word = self.word;
            let params = {
                Word: Word,
                MaxResultCount: self.maxResultCount
            };
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminPopupPromotion/GetCouponList",
                params: params,
                success(res) {
                    self.CouponList = res.items
                    self.couponTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 获取选中优惠券数量
        getCouponNum() {
            let self = this;
            self.showCoupon = false;
            let itemIDArr = [];
            self.nowCurrentPageCustomer.forEach((ele, index) => {
                itemIDArr.push(ele.couponID);
            });
            self.couponNum = itemIDArr.length;
            self.formData.couponIDs = itemIDArr;
        },
        //优惠券选择Dialog框勾选
        handleCustomerSelectionChange(val) {
            if(val.length > this.currentPageCustomer){
                this.currentPageCustomer = val;
            }
            this.nowCurrentPageCustomer = val;
        },
        //优惠券 一页显示多少个
        handleGoodsSizeChange(val) {
            let self = this;
            self.currentPageCustomerData = self.currentPageCustomerData.concat(
                self.currentPageCustomer
            );
            self.maxResultCount = val;
            let Word = self.word;
            let params = {
                Word: Word,
                MaxResultCount: val
            };
            self.goodsList = [];
            self.singleJoinItem = [];
            self.choosedJoinGoodsItem = [];
            self.oneStepLastGoods = [];
            self.secondChooseGoods = [];
            self.getCoupon(params, true);
        },
        //优惠券 跳转到指定页
        handleGoodsCurrentChange(val) {
            let self = this;
            self.loading = true;
            self.chooseCustomerData = self.chooseCustomerData.concat(
                self.currentPageCustomer
            );
            let skipCount = (val - 1) * self.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: self.maxResultCount,
                Word: self.word
            };
            self.getCoupon(params, false);
        },
    },
    created() {}
};
</script>
<style lang="scss" scoped>
.addHWPromotion {
    width: 80%;
    margin: 50px auto;
    display: block;
}
.footBtn{
    display: block;
    text-align: center;
}
.avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
.depot {
    
    // 搜索
    .seach-box {
        border: 1px solid rgba(228, 228, 228, 1);
        margin: 20px 50px;
        .title {
            display: flex;
            align-items: center;
            height: 50px;
            font-weight: 400;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding-left: 20px;
            // i:first-child {
            //   width: 18px;
            //   height: 18px;
            //   background: green;
            // }
        }
        .input-wrapper {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 40px;
            .el-search {
                width: 180px;
            }
            .status {
                margin-left: 40px;
            }
        }
    }

    // 仓库列表
    .depot-list {
        margin: 0 50px;
        border: 1px solid rgba(228, 228, 228, 1);
        font-weight: 400;
        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            .title {
                display: flex;
                align-items: center;
                height: 50px;
                font-weight: 400;
                padding-left: 20px;
                // i:first-child {
                //   width: 18px;
                //   height: 18px;
                //   background: green;
                // }
            }
        }
        .control {
            .tip-box {
                width: 80px;
                padding-left: 0;
                padding-right: 0;
                margin-right: 20px;
            }
            .select-box {
                width: 100px;
                margin-left: 20px;
            }
        }
        // 弹出框
        .add-box {
            // width: 600px;
            /deep/ .el-dialog__header {
                display: flex;
                align-items: center;
                padding-top: 14px;
                background: rgba(242, 242, 242, 1);
                font-weight: 700;
            }
            .from-el {
                width: 600px;
            }
            .input-el {
                width: 420px;
            }
        }
    }
    // 分页
    .pagination-wrapper {
        text-align: center;
        margin-top: 20px;
    }
    // 文本框
    .el-textarea {
        width: 80%;
    }
}
</style>